export default {"src":"/_next/static/media/arrow_left.f59fea27.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};